// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file proto/chordsheet/v1/chordsheet.proto (package chordsheet.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file proto/chordsheet/v1/chordsheet.proto.
 */
export const file_proto_chordsheet_v1_chordsheet: GenFile = /*@__PURE__*/
  fileDesc("CiRwcm90by9jaG9yZHNoZWV0L3YxL2Nob3Jkc2hlZXQucHJvdG8SDWNob3Jkc2hlZXQudjEiKwoVR2V0THlyaWNzUGFydHNSZXF1ZXN0EhIKCmNob3Jkc2hlZXQYASABKAkiWwoKTHlyaWNzUGFydBINCgVsYWJlbBgBIAEoCRIPCgdjb250ZW50GAIgASgJEgwKBHR5cGUYAyABKAkSHwoXaW5kZXhfYnlfdHlwZV9vbmVfYmFzZWQYBCABKAUiMwoHU3VjY2VzcxIoCgVwYXJ0cxgBIAMoCzIZLmNob3Jkc2hlZXQudjEuTHlyaWNzUGFydCJICgdGYWlsdXJlEhUKDWVycm9yX21lc3NhZ2UYASABKAkSFwoKZXJyb3JfbGluZRgCIAEoBUgAiAEBQg0KC19lcnJvcl9saW5lIngKFkdldEx5cmljc1BhcnRzUmVzcG9uc2USKQoHc3VjY2VzcxgBIAEoCzIWLmNob3Jkc2hlZXQudjEuU3VjY2Vzc0gAEikKB2ZhaWx1cmUYAiABKAsyFi5jaG9yZHNoZWV0LnYxLkZhaWx1cmVIAEIICgZyZXN1bHQycgoRQ2hvcmRTaGVldFNlcnZpY2USXQoOR2V0THlyaWNzUGFydHMSJC5jaG9yZHNoZWV0LnYxLkdldEx5cmljc1BhcnRzUmVxdWVzdBolLmNob3Jkc2hlZXQudjEuR2V0THlyaWNzUGFydHNSZXNwb25zZWIGcHJvdG8z");

/**
 * @generated from message chordsheet.v1.GetLyricsPartsRequest
 */
export type GetLyricsPartsRequest = Message<"chordsheet.v1.GetLyricsPartsRequest"> & {
  /**
   * @generated from field: string chordsheet = 1;
   */
  chordsheet: string;
};

/**
 * Describes the message chordsheet.v1.GetLyricsPartsRequest.
 * Use `create(GetLyricsPartsRequestSchema)` to create a new message.
 */
export const GetLyricsPartsRequestSchema: GenMessage<GetLyricsPartsRequest> = /*@__PURE__*/
  messageDesc(file_proto_chordsheet_v1_chordsheet, 0);

/**
 * @generated from message chordsheet.v1.LyricsPart
 */
export type LyricsPart = Message<"chordsheet.v1.LyricsPart"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: int32 index_by_type_one_based = 4;
   */
  indexByTypeOneBased: number;
};

/**
 * Describes the message chordsheet.v1.LyricsPart.
 * Use `create(LyricsPartSchema)` to create a new message.
 */
export const LyricsPartSchema: GenMessage<LyricsPart> = /*@__PURE__*/
  messageDesc(file_proto_chordsheet_v1_chordsheet, 1);

/**
 * @generated from message chordsheet.v1.Success
 */
export type Success = Message<"chordsheet.v1.Success"> & {
  /**
   * @generated from field: repeated chordsheet.v1.LyricsPart parts = 1;
   */
  parts: LyricsPart[];
};

/**
 * Describes the message chordsheet.v1.Success.
 * Use `create(SuccessSchema)` to create a new message.
 */
export const SuccessSchema: GenMessage<Success> = /*@__PURE__*/
  messageDesc(file_proto_chordsheet_v1_chordsheet, 2);

/**
 * @generated from message chordsheet.v1.Failure
 */
export type Failure = Message<"chordsheet.v1.Failure"> & {
  /**
   * @generated from field: string error_message = 1;
   */
  errorMessage: string;

  /**
   * @generated from field: optional int32 error_line = 2;
   */
  errorLine?: number | undefined;
};

/**
 * Describes the message chordsheet.v1.Failure.
 * Use `create(FailureSchema)` to create a new message.
 */
export const FailureSchema: GenMessage<Failure> = /*@__PURE__*/
  messageDesc(file_proto_chordsheet_v1_chordsheet, 3);

/**
 * @generated from message chordsheet.v1.GetLyricsPartsResponse
 */
export type GetLyricsPartsResponse = Message<"chordsheet.v1.GetLyricsPartsResponse"> & {
  /**
   * @generated from oneof chordsheet.v1.GetLyricsPartsResponse.result
   */
  result: {
    /**
     * @generated from field: chordsheet.v1.Success success = 1;
     */
    value: Success;
    case: "success";
  } | {
    /**
     * @generated from field: chordsheet.v1.Failure failure = 2;
     */
    value: Failure;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chordsheet.v1.GetLyricsPartsResponse.
 * Use `create(GetLyricsPartsResponseSchema)` to create a new message.
 */
export const GetLyricsPartsResponseSchema: GenMessage<GetLyricsPartsResponse> = /*@__PURE__*/
  messageDesc(file_proto_chordsheet_v1_chordsheet, 4);

/**
 * @generated from service chordsheet.v1.ChordSheetService
 */
export const ChordSheetService: GenService<{
  /**
   * @generated from rpc chordsheet.v1.ChordSheetService.GetLyricsParts
   */
  getLyricsParts: {
    methodKind: "unary";
    input: typeof GetLyricsPartsRequestSchema;
    output: typeof GetLyricsPartsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_proto_chordsheet_v1_chordsheet, 0);

